import React, { useState } from 'react';
import { getDemoPhotos } from './demoPhotos';

export default function Gallery({
  media = [],
  category = 'Matrimonios',
  accent = '#b8935a',
  text = '#1f2937',
  muted = '#6b7280',
  title = 'Galería',
  subtitle = 'Recuerdos',
  headingFont = "'Playfair Display', serif",
  showDemo = true, // si no hay fotos reales, muestra demo
  maxPhotos = 6,
}) {
  const [selected, setSelected] = useState(null);

  // Decide qué fotos mostrar
  const hasRealPhotos = media && media.length > 0;
  const photosToShow = hasRealPhotos
    ? media.slice(0, maxPhotos)
    : showDemo
    ? getDemoPhotos(category).slice(0, maxPhotos)
    : [];

  // Si no hay nada que mostrar, no renderiza
  if (photosToShow.length === 0) return null;

  // Layout adaptativo: 1 foto = centrada, 2 = 2 col, 3+ = 3 col
  const cols =
    photosToShow.length === 1
      ? 'grid-cols-1 max-w-md mx-auto'
      : photosToShow.length === 2
      ? 'grid-cols-2 max-w-2xl mx-auto'
      : 'grid-cols-2 md:grid-cols-3';

  return (
    <section className="px-6 py-16">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <p
            className="text-[10px] tracking-[0.5em] uppercase mb-3"
            style={{ color: accent }}
          >
            {subtitle}
          </p>
          <h2
            className="text-3xl sm:text-4xl mb-4"
            style={{ fontFamily: headingFont, fontWeight: 600, color: text }}
          >
            {title}
          </h2>
          <div
            className="h-px w-24 mx-auto"
            style={{ background: accent, opacity: 0.5 }}
          />

          {/* Badge "ejemplo" cuando son demo */}
          {!hasRealPhotos && showDemo && (
            <p
              className="mt-4 text-[10px] tracking-[0.3em] uppercase"
              style={{ color: muted, opacity: 0.6 }}
            >
              Fotos de ejemplo
            </p>
          )}
        </div>

        <div className={`grid ${cols} gap-3`}>
          {photosToShow.map((m) => (
            <button
              key={m.id}
              type="button"
              onClick={() => setSelected(m)}
              className="block w-full overflow-hidden rounded-lg bg-slate-100 group relative aspect-square"
            >
              <img
                src={m.url}
                alt={m.alt || ''}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition"
                style={{ background: 'linear-gradient(180deg,transparent,rgba(0,0,0,0.15))' }}
              />
            </button>
          ))}
        </div>
      </div>

      {selected && (
        <div
          className="fixed inset-0 z-50 bg-black/90 grid place-items-center p-4 cursor-pointer"
          onClick={() => setSelected(null)}
        >
          <img
            src={selected.url}
            alt={selected.alt || ''}
            className="max-w-full max-h-full object-contain"
          />
          <button
            type="button"
            className="absolute top-4 right-4 text-white text-3xl leading-none w-10 h-10 grid place-items-center rounded-full bg-white/10 hover:bg-white/20"
            onClick={() => setSelected(null)}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
      )}
    </section>
  );
}